import { render, staticRenderFns } from "./publicInfoHome.vue?vue&type=template&id=40dd3729"
import script from "./publicInfoHome.vue?vue&type=script&lang=js"
export * from "./publicInfoHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports